import CategoryRow from './CategoryRow';
import createNewCategoryRow from '../actions/createNewCategoryRow';
import store from '../store/store';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { getMasterCategoryList } from 'owa-categories';
import { ControlIcons } from 'owa-control-icons';
import { OptionDescription } from 'owa-options-controls';
import CategoryType from 'owa-service/lib/contract/CategoryType';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

let styles = require('./CategoriesFull.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CategoriesFullProps {
    newCategory?: CategoryType;
}

@reactive({
    newCategory: () => store.newCategory,
})
export default class CategoriesFull extends React.Component<CategoriesFullProps, {}> {
    render() {
        let newCategory = this.props.newCategory;
        let masterList = getMasterCategoryList();
        let categoryRowsToRender: JSX.Element[] = [];

        // Render the row for new category
        if (newCategory.Id) {
            categoryRowsToRender.push(
                <CategoryRow
                    key={'new_categoryRow'}
                    id={newCategory.Id}
                    isNewCategoryRow={true}
                    name={newCategory.Name}
                    colorId={newCategory.Color.toString()}
                />
            );
        }

        // Render master category list in reverse order, so the latest category always shows on top
        for (let i = masterList.length - 1; i >= 0; i--) {
            let categoryType = masterList[i];
            categoryRowsToRender.push(
                <CategoryRow
                    key={categoryType.Id}
                    id={categoryType.Id}
                    isNewCategoryRow={false}
                    name={categoryType.Name}
                    colorId={categoryType.Color.toString()}
                />
            );
        }

        return (
            <div>
                <OptionDescription className={styles.emptyRules}>
                    {strings.options_categories_description_general}
                </OptionDescription>
                <ActionButton
                    className={styles.createCategoryButton}
                    onClick={this.onCreateNewCategory}
                    text={strings.options_create_category}
                    iconProps={{
                        iconName: ControlIcons.Add,
                        styles: {
                            root: classNames(styles.icon, 'flipForRtl'),
                        },
                    }}
                />
                {categoryRowsToRender}
            </div>
        );
    }

    private onCreateNewCategory = (ev: React.MouseEvent<EventTarget>) => {
        createNewCategoryRow();
    };
}
